export const DOMAIN_CHART_CONTAINER_COPY = {
  lineChartWell:
    'This chart illustrates change over time in the domain index score. Index scores are relative measures and display performance compared to other communities in the same time frame.',
  histogramWell:
    'This chart illustrates the distribution of domain index scores across the selected benchmark cohort. Index scores are relative measures and display performance compared to other communities in the same time frame.',
};
